<script lang="ts">
  // A repository's page (docs/design.md "Repository page"): its open pull requests, the default tab at the page's
  // own path, and its branches, each a pivot to its compare, its history, or its pull request.
  import { repoPath, type RepoTab } from '../lib/router';
  import RepoPulls from './RepoPulls.svelte';
  import RepoBranches from './RepoBranches.svelte';

  interface Props {
    owner: string;
    repo: string;
    tab: RepoTab;
  }
  let { owner, repo, tab }: Props = $props();

  $effect(() => {
    document.title = `${tab === 'branches' ? 'Branches · ' : ''}${owner}/${repo}`;
  });

  const TABS: { tab: RepoTab; label: string }[] = [
    { tab: 'pulls', label: 'Pull requests' },
    { tab: 'branches', label: 'Branches' },
  ];
</script>

<header class="top">
  <!-- The page's heading, for its outline; to the eye, the top bar's location line names it. -->
  <h1 class="sr-only">{owner}/{repo}</h1>
  <nav class="repo-tabs" aria-label="{owner}/{repo} sections">
    {#each TABS as t (t.tab)}
      <a href={repoPath(owner, repo, t.tab)} aria-current={t.tab === tab ? 'page' : undefined}>{t.label}</a>
    {/each}
  </nav>
</header>
{#if tab === 'pulls'}
  <RepoPulls {owner} {repo} />
{:else}
  <RepoBranches {owner} {repo} />
{/if}

<style>
  .repo-tabs {
    display: flex;
    gap: 4px;
  }
  .repo-tabs a {
    padding: 4px 10px;
    border-radius: 6px;
    color: var(--fg);
    text-decoration: none;
    font-size: 13px;
  }
  .repo-tabs a[aria-current='page'] {
    background: var(--code);
    font-weight: 650;
  }
</style>
